import { useEffect, useState } from "react";
import { getRecommendations, generateHealthManual } from "../utils/cancerRecommendations";
import { getHealthScreeningRecommendations } from "../utils/healthScreeningRecommendations";
import ResultPageV2 from "./ResultPageV2";

// Demo persona: 52F Asian, family history of GI + breast cancer, unhealthy diet, moderate drinker
// Age 52 triggers gov-recommended badges for breast, cervical, and colorectal
// Uses the actual field names that getRecommendations expects
const DEMO_SURVEY_DATA = {
  biologicalSex: "female",
  age: 52,
  ethnicity: "asian",
  height: 162,        // cm (engine uses this)
  weight: 54,         // kg (engine uses this)
  heightInCm: 162,    // for v2 BMI calc
  weightInKg: 54,     // for v2 BMI calc
  familyCancerHistory: ["gastrointestinal", "breast"],
  chronicDiseases: [],
  smokingHistory: 0,
  cigarettesPerDay: 0,
  livedWithSmoker: "no",
  radiationExposure: "no",
  alcoholConsumption: "7_to_14",
  dietHabits: "yes",  // "yes" = unhealthy processed diet
};

export default function DemoResultPageV2() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const surveyData = DEMO_SURVEY_DATA;
    const recommendations = getRecommendations(surveyData, "en");
    const healthManual = generateHealthManual(surveyData, "en");
    const healthScreening = getHealthScreeningRecommendations(surveyData);

    localStorage.setItem(
      "omnicare_analysis_results",
      JSON.stringify({ surveyData, recommendations, healthManual, healthScreening })
    );
    setReady(true);
  }, []);

  if (!ready) return null;
  return <ResultPageV2 />;
}
